import React from 'react'

const FooterText = () => (
    <span className="pn-footer-text">Only you can see this private note</span>
)

export default FooterText